export default __webpack_public_path__ + "static/media/sapphire4.c379542a.jpg";